import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { LayoutModule } from '../Layout/layout.module';
import { CardComponent } from './components/card/card.component';
import { DocumentsNameDisplayComponent } from './components/documents-name-display/documents-name-display.component';
import { EditableTextCaseComponent } from './components/editable-text-case/editable-text-case.component';
import { ExportTableComponent } from './components/export-table/export-table.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateSingleNoLoaderPipe, TranslateSinglePipe } from '@evolutics/translation';
import {
  AddItemComponent,
  AutocompleteModule,
  BtnModule,
  ComponentsModule,
  DetailsBtnComponent,
  FindItemComponent,
  FormErrorComponent,
  FormGeneratorComponent,
  InputComponents,
  InputNGModelComponent,
  LabelComponent,
  LoaderComponent,
  PhoneNumberComponent,
  RowActionsComponent,
  SDKTranslateNoLoaderPipe,
  TableHttpsComponent,
  TablePlainComponent,
  TextCase1Component,
  TextCase2Component,
  TextCaseInputComponent,
  ToggleInputFormComponent,
  ModalBodyDirective,
  ModalFooterDirective,
} from 'ets-fe-ng-sdk';
import { FormLinkComponent } from './components/form-link/form-link.component';
import { FormTabHeadersComponent } from './components/form-tab-headers/form-tab-headers.component';
import { InfoIconComponent } from './components/info-icon/info-icon.component';
import { PageToComponentComponent } from './components/page-to-component/page-to-component.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { TextComponent } from './components/text/text.component';
import { TranslatorCaseComponent } from './components/translator-case/translator-case.component';
import { UserPreviewModalComponent } from './components/user-preview-modal/user-preview-modal.component';
import { ViewFormButtonsComponent } from './components/view-form-buttons/view-form-buttons.component';
import { DirectivesModule } from './directives/index.directive';
import { UtilityPipesModule } from './pipes/utility.pipe';
import { ModalHeaderComponent } from './components/modal-header/modal-header.component';
import { ModalFormComponent } from './components/modal-form/modal-form.component';
import { ModalComponent } from './components/modal/modal.component';
import { PageTemplateComponent } from './components/page-template/page-template.component';

export const _SharedModule = [
  ...AutocompleteModule,
  ...BtnModule,
  ...InputComponents,
  AddItemComponent,
  CardComponent,
  CommonModule,
  ComponentsModule,
  DetailsBtnComponent,
  DirectivesModule,
  DocumentsNameDisplayComponent,
  EditableTextCaseComponent,
  ExportTableComponent,
  FindItemComponent,
  FontAwesomeModule,
  FormErrorComponent,
  FormGeneratorComponent,
  FormLinkComponent,
  FormsModule,
  FormTabHeadersComponent,
  InfoIconComponent,
  InputNGModelComponent,
  LabelComponent,
  LayoutModule,
  LoaderComponent,
  MatButtonModule,
  MatDialogModule,
  MatExpansionModule,
  MatMenuModule,
  MatSlideToggleModule,
  MatTooltipModule,
  ModalBodyDirective,
  ModalComponent,
  ModalFooterDirective,
  ModalFormComponent,
  ModalHeaderComponent,
  PageTemplateComponent,
  PageToComponentComponent,
  PhoneNumberComponent,
  ReactiveFormsModule,
  RouterModule,
  RowActionsComponent,
  SDKTranslateNoLoaderPipe,
  SvgIconComponent,
  TableHttpsComponent,
  TablePlainComponent,
  TextCase1Component,
  TextCase2Component,
  TextCaseInputComponent,
  TextComponent,
  ToggleInputFormComponent,
  TranslateSingleNoLoaderPipe,
  TranslateSinglePipe,
  TranslatorCaseComponent,
  UserPreviewModalComponent,
  UtilityPipesModule,
  ViewFormButtonsComponent,
] as const;

@NgModule({
  declarations: [],
  imports: [CommonModule, ..._SharedModule],
  exports: [..._SharedModule],
  providers: [DecimalPipe],
})
export class SharedModule {}
